import { CommonStyles } from '../../../common/react/CommonStyles';
import { cssClass } from '../../../style';

export namespace CollectionsDialogStyles {
  const cssPrefix: string = 'collections-dialog';
  export const ADD_TO_DIALOG_WIDTH = 400;
  export const COLLECTION_MARGIN = 12;
  export const COLLECTION_HEIGHT = 20;
  export const COLLECTION_ITEM_HEIGHT = COLLECTION_HEIGHT + COLLECTION_MARGIN;

  export const Spinner = cssClass(cssPrefix, 'spinner', {
    marginTop: '48px',
    marginBottom: '48px',
    textAlign: 'center'
  });

  export const ItemsToAdd = cssClass(cssPrefix, 'items-to-add', {
    marginBottom: CommonStyles.Sizes.LargeSpace,
  });

  export const CreateCollectionContainer = cssClass(cssPrefix, 'create-collection-container', {
    marginTop: CommonStyles.Sizes.LargeSpace,
    marginBottom: CommonStyles.Sizes.LargeSpace,
  });

  export const CollectionsList = cssClass(cssPrefix, 'collections-list', {
    maxHeight: '200px',
    overflowY: 'auto',
  });

  export const ActionButtons = cssClass(cssPrefix, 'action-buttons', {
    marginTop: CommonStyles.Sizes.LargeSpace,
    textAlign: 'right',
    whiteSpace: 'nowrap',
  });

  export const CheckBoxContainer: React.CSSProperties = {
    marginTop: COLLECTION_MARGIN,
    marginBottom: COLLECTION_MARGIN,
    height: COLLECTION_HEIGHT,
  };
}
